import YouTube, { Options } from 'react-youtube';
import { useEffect, useRef, useState } from 'react';
import { EVENT_STATUS } from 'global/LiveStreamWidget/constants';
import { StreamBoxLeftWrapper, VideoPlayerContainer, YoutubeContainer } from './styled';
import PlayerBanner from './PlayerBanner';
import WidgetHostDetail from './WidgetHostDetail';

interface StreamBoxLeftProps {
  event: any;
}

function StreamBoxLeft({ event }: StreamBoxLeftProps) {
  const {
    media,
    status,
    host: {
      description,
      name,
      logo_url: logoUrl,
    },
  } = event;

  const {
    thumbnail_url: thumbnailUrl,
    thumbnail_upcoming_url: thumbnailUpcoming,
  } = media;
  const playerRef = useRef < any >();

  const [showBanner, setShowBanner] = useState(false);

  const youtubeOptions: Options = {
    width: '100%',
    height: '360',
    playerVars: {
      mute: 0,
    },
  };

  const onClickPlay = () => {
    setShowBanner(false);
    playerRef?.current?.internalPlayer?.playVideo();
  };

  useEffect(() => {
    if (thumbnailUrl !== '' && status !== EVENT_STATUS.LIVE) {
      setShowBanner(true);
    } else if (thumbnailUpcoming !== '' && status === EVENT_STATUS.UPCOMING) {
      setShowBanner(true);
    }
  }, []);

  const isLive = status === EVENT_STATUS.LIVE;
  const isEnded = status === EVENT_STATUS.ENDED;
  const isCanPlay = isLive || isEnded;
  const thumbUrl = isEnded && thumbnailUrl !== '' ? thumbnailUrl : thumbnailUpcoming;

  return (
    <StreamBoxLeftWrapper>
      <VideoPlayerContainer style={{ display: showBanner ? 'none' : 'block' }}>
        <YoutubeContainer>
          <YouTube
            videoId={media.id}
            opts={youtubeOptions}
            ref={playerRef}
            id="livestream-youtube-player"
          />
        </YoutubeContainer>
      </VideoPlayerContainer>
      {showBanner && <PlayerBanner image={thumbUrl} isCanPlay={isCanPlay} onPlay={onClickPlay} />}
      <WidgetHostDetail
        description={description}
        name={name}
        logoUrl={logoUrl}
      />
    </StreamBoxLeftWrapper>
  );
}

export default StreamBoxLeft;
